import { es } from '@/textos/es'

export function Cargando({ texto = es.comun.cargando }: { texto?: string }) {
  return (
    <div role="status" className="flex items-center gap-3 p-8 text-small text-tinta-3">
      <span
        aria-hidden
        className="h-4 w-4 animate-spin rounded-full border-2 border-linea border-t-brand"
      />
      {texto}
    </div>
  )
}
